<template>
  <div class="stories-home">
    <VueSlickCarousel
      class="marquee"
      :infinite="true"
      :autoplay="true"
      :autoplaySpeed="0"
      :cssEase="'linear'"
      :dots="false"
      :arrows="false"
      :speed="10000"
      :variableWidth="true"
      :slidesToShow="1"
    >
      <div v-for="index in 7" :key="`copy-${index}`" class="marquee-element">
        <h1>Strategy and Analytics</h1>
        <img class="fs-logo" src="images/FSI_Home_Logo.png" alt="Fox Sports">
      </div>
    </VueSlickCarousel>

    <div class="stories-container">
      <StoryList
        :visible="showing == 'stories'"
        :items="activeItems(stories)"
        type="stories"
        @clicked="setActive('stories')"
      />

      <StoryList
        :visible="showing == 'articles'"
        :items="activeItems(articles)"
        type="articles"
        @clicked="setActive('articles')"
      />
    </div>
    <div class="bottom">
      <div class="left">
        <p>The Fan Mosaic is a proprietary platform that brings fans into focus through powerfully evocative storytelling.</p>
      </div>
      <div class="right">
        <p>INTERNAL USE ONLY</p>
        <p>Contact: ben.valenta@fox.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import StoryList from '@/components/StoryList'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: {
    VueSlickCarousel,
    StoryList
  },

  data () {
    return {
      showing: 'stories',
      stories: [
        {
          program: 'College Football',
          title: 'More Than a Game',
          link: '/college-football',
          type: 'story',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FFSI_CFB_Homepage_preview_COMP.gif?alt=media&token=bb5c6395-4046-499d-adf1-537c03f952b4'
        },
        {
          program: 'Studio Shows',
          title: 'Talk the Talk',
          link: '/studio-shows',
          type: 'story',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FFSI_SS_HomePage_preview_COMP.gif?alt=media&token=2bba7866-b0c8-4185-a2ee-008f654743c9'
        },
        {
          program: 'Sports Betting',
          title: 'Smart Money',
          link: '/betting',
          type: 'story',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FSMARTMONEY_GIF_1A_SMALLER.gif?alt=media&token=f3ca50d1-0279-43b3-a63e-c336af238235'
        },
        {
          program: 'Nascar',
          title: 'Fellowship of Speed',
          link: '/nascar',
          type: 'story',
          video: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FFS_NAS_INDEX01_1.mp4?alt=media&token=fb525a50-350f-4eb9-b563-6365adcd108f'
        },
        {
          program: 'NFL',
          title: 'Unsung Heroines',
          link: '/stories/nfl-female-fans',
          type: 'story',
          video: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FNFLFemaleFans_preview.mp4?alt=media&token=845f7332-714b-4ced-ada8-d0ab814c8d41'
        },
        {
          program: 'MLB',
          title: 'Classic Now',
          link: '/stories/mlb',
          type: 'story',
          video: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FFOXSPORTS_MLB_CLIP_200PX.mp4?alt=media&token=330e0242-6ce2-4940-b9df-4cd08ac2bc2f'
        }
      ],
      articles: [
        {
          program: 'Sports Betting',
          title: 'Valuing the Bettor',
          link: '/articles/valuing-the-bettor',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FFoxSports_FMAH_Assets-1_SMALL.jpg?alt=media&token=64876a91-6b93-4972-9d7c-d9bdb74a509e',
        },
        {
          program: 'Ratings',
          title: '2020 Ratings Review',
          link: '/articles/ratings-review-2020',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2Fratings-2020_SMALL.png?alt=media&token=51e43143-c2e3-4d5b-966f-584e3a51c9b4',
        },
        {
          program: 'Sports Betting',
          title: 'Betting\'s Knowledge Gap',
          link: '/articles/bettings-knowledge-gap',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2Fhero-compressed_SMALL.jpg?alt=media&token=e0777e2b-2a1a-4da8-a3f5-71ede1c1f526'
        },
        {
          program: 'ATSC 3.0',
          title: 'Understanding ATSC 3.0',
          link: '/articles/atsc-3.0',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FSketch-1_V4A_Compressed.jpg?alt=media&token=13c9edd5-ca71-4fa8-b336-880bbfedaa10'
        },
        {
          program: 'College Basketball',
          title: 'College Basketball',
          link: '/articles/cbb-fans',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2F191203_KNOTT_DUKE_MSU_IMG_1973%20SMALL.jpeg?alt=media&token=15d6d056-5eda-4cf1-8773-1b4eafe7430d'
        },
        {
          program: 'NFL',
          title: 'NFL Female Fans',
          link: '/articles/nfl-female-fans',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2FNFL_02-1.jpg?alt=media&token=8f26a1cf-9f37-4d2d-9605-f91f4e72f192'
        },
        {
          program: 'FOX',
          title: 'Fox Brand Perceptions',
          link: '/articles/fox-brand-perceptions',
          type: 'article',
          image: 'https://firebasestorage.googleapis.com/v0/b/foxsports-fanmosaic-prod.appspot.com/o/stories%2Fhome%2Fhero_final_new_planetary_model_of_fox_sports_universe_Glandien%20New%20Final%20SMALL.jpeg?alt=media&token=640db60d-ebd6-41e7-9269-af38523be558'
        }
      ]
    }
  },

  computed: {
  },
  methods: {
    activeItems (target) {
      const active = []
      target.forEach((item) => {
        if (!item.disabled) {
          active.push(item)
        }
      })
      return active
    },
    setActive (type) {
      console.log(type)
      this.showing = type
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';
.stories-home {
  font-family: $font-body;
}
.stories-container {
  position: relative;
  padding: 0 $space-m;
  height: calc(100vh - 260px);

  @include media($bp-desktop-l) {
    height: calc(100vh - 285px);
  }

  @include media($bp-desktop-s) {
    height: calc(100vh - 310px);
  }

  @include media($bp-tablet) {
    height: calc(100vh - 325px);
  }
  @include media($bp-phone-l) {
    height: 524px;
  }

  .stories-list {
    display: inline-block;
    vertical-align: top;
    width: 50%;

    @include media($bp-tablet) {
      display: block;
      width: 100%;
    }
  }
}
.marquee {
  pointer-events: none;
  max-height: 130px;
  overflow: hidden;
  
  .marquee-element {
    padding: $space-m $space-m;
    text-transform: uppercase;

    h1, .fs-logo {
      vertical-align: middle;
      display: inline-block;
    }

    .fs-logo {
      margin-left: $space-l;
      height: 55px;
    }
  }
  .slick-slide {
    h1 {
      font-size: 27px;
    }
  }

  @include media($bp-phone-l) {
    .marquee-element {
      padding: 28px $space-s;
      .fs-logo {
        height: 40px;
        margin-left: $space-ms;
      }
    }
    .slick-slide {
      h1 {
        font-size: 18px;
      }
    }
  }
}

.bottom {
  width: 100%;

  > div {
    display: inline-block;
    vertical-align: top;
    width: 50%;

    p {
      margin: 0;
    }

    &.left {
      padding: 40px 20px 40px 40px;
    }
    &.right {
      padding: 40px 40px 40px 20px;
    }

    @include media($bp-tablet) {
      display: block;
      width: 100%;

      &.left {
        padding: 24px;
      }
      &.right {
        padding: 0 24px 24px 50px;
      }
    }

    @include media-height($hbp-tablet) {
      font-size: 14px;
    }

    @include media($bp-phone-l) {
      font-size: 12px;
    }
  }
}
</style>